module.exports = __webpack_public_path__ + "static/img/hua3.b60fe69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua3.png
// module id = MIHv
// module chunks = 22